module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('h2', {}, [_vm._v("HotSchedules Academy Mappings")]), _vm._v(" "), _c('div', {
    staticClass: "academy-listings"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0dac430f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 405
// module chunks = 2